import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=6728c74b&scoped=true&"
import script from "./IconButton.vue?vue&type=script&lang=ts&"
export * from "./IconButton.vue?vue&type=script&lang=ts&"
import style0 from "./IconButton.vue?vue&type=style&index=0&id=6728c74b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6728c74b",
  null
  
)

export default component.exports